import React, { useEffect, useRef, useState } from "react";
const AvaitorResult = ({ resultData }) => {
  //console.log("resultData.length->", resultData);

  return (
    <div className="tabcontent" style={{ display: "block" }}>
      <div className="left-content">
        <div className="cardAV">
          <div className="card-headerAV">Results for Last 50 Rounds</div>
          <div className="card-bodyAV">
            <div className="rowAV">
              {resultData !== null &&
                Object.values(resultData).map((value, index) => (
                  <div className="colAV" key={`${index}-${value}`}>
                    <div
                      className={
                        value > 2
                          ? "result-itemAV border-normal"
                          : "result-itemAV border-red"
                      }
                    >
                      {" "}
                      {value}
                    </div>
                  </div>
                ))}

              {/*} <div className="colAV">
                <div className="result-itemAV border-golden">20.01</div>
              </div>
              <div className="colAV">
                <div className="result-itemAV border-red">1.11</div>
              </div>
              <div className="colAV">
                <div className="result-itemAV border-red">1.62</div>
              </div>
              <div className="colAV">
                <div className="result-itemAV border-red">1.54</div>
              </div>
              <div className="colAV">
                <div className="result-itemAV border-normal">2.02</div>
              </div>
              <div className="colAV">
                <div className="result-itemAV border-red">1.30</div>
              </div>
              <div className="colAV">
                <div className="result-itemAV border-red">1.36</div>
              </div>
              <div className="colAV">
                <div className="result-itemAV border-red">1.24</div>
              </div>
              <div className="colAV">
                <div className="result-itemAV border-normal">3.43</div>
              </div>*/}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AvaitorResult;
